<template>
  <div>
    <v-container
      fluid
      :class="{
        'mx-12': !mobile,
        'my-6': !mobile,
        'mx-0': mobile,
        'my-3': mobile
      }"
    >
      <div v-if="!mobile" class="card-label d-flex flex-row mb-4">
        <v-icon>mdi-bulletin-board</v-icon>
        <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Announcements</p>
      </div>
      <v-row
        v-else
        no-gutters
        :class="{
          'mb-4': !mobile,
          'mb-0': mobile
        }"
      >
        <v-col cols="1">
          <v-icon>mdi-bulletin-board</v-icon>
        </v-col>
        <v-col>
          <p class="mx-4 subtitle-1 font-weight-bold">Announcements</p>
        </v-col>
        <v-col class="d-flex justify-end align-center">
          <v-btn
            class="font-weight-bold"
            color="primary"
            depressed
            :disabled="!access.create"
            x-small
            @click="newAnnouncement"
          >
            <v-icon small>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mb-6">
        <v-col
          cols="12"
          sm="6"
          md="6"
          :class="{
            'py-0': !mobile,
            'my-1': mobile
          }"
        >
          <v-text-field
            v-model="searchString"
            solo
            flat
            append-icon="mdi-magnify"
            label="Search Announcement"
            hide-details
            @click:append="searchAction"
            @keydown.enter="searchAction"
          >
          </v-text-field>
        </v-col>
        <v-col class="py-0" cols="12" sm="3" md="3">
          <v-select
            v-model="selectedStatuses"
            solo
            flat
            hide-details
            label="Show Status"
            :items="statuses"
            multiple
            @change="searchAction"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="selectAllStatuses">
                <v-list-item-action>
                  <v-icon
                    :color="
                      selectedStatuses.length > 0 ? 'indigo darken-4' : ''
                    "
                    >{{ iconStatuses }}</v-icon
                  >
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text caption"
                >(+{{ selectedStatuses.length - 1 }} others)</span
              >
            </template>
          </v-select>
        </v-col>
        <v-col v-if="!mobile" class="py-0" cols="12" sm="3" md="3">
          <v-btn
            class="font-weight-bold"
            color="primary"
            depressed
            :disabled="!access.create"
            block
            @click="newAnnouncement"
          >
            <v-icon class="pr-1">mdi-plus</v-icon>
            New Announcement
          </v-btn>
        </v-col>
      </v-row>
      <v-card
        v-if="access.read"
        v-show="!loading"
        elevation="0"
        :class="{
          'px-8': !mobile,
          'py-4': !mobile,
          'px-2': mobile,
          'pb-2': mobile
        }"
      >
        <v-data-table
          :headers="headers"
          :items="announcements"
          :options.sync="options"
          :server-items-length="total"
          item-key="announcementId"
          :loading="loading"
          loading-text="Loading... Please wait"
          hide-default-header
          no-data-text="Tenants part of your property will be notified when an announcement is created."
          :footer-props="{
            'items-per-page-options': !mobile ? [10, 20, 50, 100] : []
          }"
          mobile-breakpoint="600"
        >
          <template v-slot:body="{ items }">
            <v-list three-line>
              <template v-for="(item, index) in announcements">
                <v-list-item v-if="!mobile" :key="item._id">
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-content>
                      <v-list-item-title
                        ><p class="body-2 font-weight-bold">
                          {{ item.subject }}
                        </p></v-list-item-title
                      >
                      <!-- <v-list-item-subtitle class="text--primary" v-text="item.startDate + ' - ' + item.endDate"></v-list-item-subtitle> -->
                      <v-list-item-subtitle
                        ><p class="caption">
                          {{ item.message }}
                        </p></v-list-item-subtitle
                      >
                      <v-card-text
                        v-if="item.attachments.length > 0"
                        class="pa-0 pt-2"
                      >
                        <v-list-item-action-text
                          >Attachments</v-list-item-action-text
                        >
                        <v-chip-group multiple column class="pt-0">
                          <v-chip
                            v-for="file in item.attachments"
                            :key="file._id"
                            small
                            outlined
                            color="primary"
                            :href="file.url"
                            class="mx-2"
                          >
                            <div class="chip-label">
                              {{ file.filename }}
                            </div>
                          </v-chip>
                        </v-chip-group>
                      </v-card-text>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-list-item-action-text>{{
                        item.startDate + ' - ' + item.endDate
                      }}</v-list-item-action-text>
                      <v-list-item-action-text class="d-flex flex-row">
                        Status:
                        <p v-if="item.status !== 'expired'" class="ml-1">
                          {{ getStatusText(item.status) }}
                        </p>
                        <p v-else class="ml-1 red--text">
                          {{ getStatusText(item.status) }}
                        </p>
                      </v-list-item-action-text>
                    </v-list-item-action>
                  </template>
                </v-list-item>

                <v-list-item v-else :key="item._id">
                  <!-- MOBILE VIEW  -->
                  <v-list-item-content>
                    <v-list-item-title
                      ><p class="body-2 font-weight-bold my-2">
                        {{ item.subject }}
                      </p></v-list-item-title
                    >
                    <v-list-item-subtitle
                      ><p class="caption mb-3">
                        {{ item.message }}
                      </p></v-list-item-subtitle
                    >
                    <v-card-text
                      v-if="item.attachments.length > 0"
                      class="pa-0 pt-2"
                    >
                      <v-list-item-action-text
                        >Attachments</v-list-item-action-text
                      >
                      <v-chip-group multiple column class="pt-0">
                        <v-chip
                          v-for="file in item.attachments"
                          :key="file._id"
                          small
                          outlined
                          color="primary"
                          :href="file.url"
                          class="mx-2"
                        >
                          <div class="chip-label">
                            {{ file.filename }}
                          </div>
                        </v-chip>
                      </v-chip-group>
                    </v-card-text>
                    <v-list-item-subtitle
                      ><p class="date mb-1">
                        {{
                          convertDate(item.startDate) +
                          ' - ' +
                          convertDate(item.endDate)
                        }}
                      </p></v-list-item-subtitle
                    >
                    <v-list-item-subtitle>
                      <p v-if="item.status !== 'expired'" class="status">
                        Status:
                        <span class="font-weight-bold">{{
                          getStatusText(item.status)
                        }}</span>
                      </p>
                      <p v-else class="status red--text">
                        Status: {{ getStatusText(item.status) }}
                      </p>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider
                  v-if="!(index >= announcements.length - 1)"
                  :key="'divider-' + index"
                ></v-divider>
              </template>
              <p
                v-if="!announcements.length"
                class="mx-4 body-2"
                style="color: grey"
              >
                Tenants of this property will be notified when an announcement
                is created.
              </p>
            </v-list>
          </template>
        </v-data-table>
      </v-card>
      <v-skeleton-loader
        v-show="loading"
        ref="skeleton"
        type="table"
        loading
        class="mx-auto"
      ></v-skeleton-loader>
    </v-container>
    <NewAnnouncement ref="newAnnouncement"></NewAnnouncement>
    <!-- <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->
  </div>
</template>

<script>
import { dayjs } from '../util/date'
import NewAnnouncement from '../components/announcements/NewAnnouncement'

export default {
  components: {
    NewAnnouncement
  },
  data() {
    return {
      searchString: '',
      loading: true,
      limit: 0,
      total: 0,
      options: {
        itemsPerPage: 5
      },
      fab: false,
      selectedStatuses: [],
      statuses: [
        {
          text: 'Upcoming',
          value: 'upcoming'
        },
        {
          text: 'Active',
          value: 'active'
        },
        {
          text: 'Expired',
          value: 'expired'
        }
      ]
    }
  },
  computed: {
    announcements() {
      return this.$store.getters['announcements/getAnnouncements']
    },
    headers() {
      return this.$store.getters['announcements/getHeaders']
    },
    access() {
      return this.$root.$roleAccess('announcements').access
    },
    allStatusesSelected() {
      return this.selectedStatuses.length === this.statuses.length
    },
    someStatusesSelected() {
      return this.selectedStatuses.length > 0 && !this.allStatusesSelected
    },
    iconStatuses() {
      if (this.allStatusesSelected) return 'mdi-close-box'
      if (this.someStatusesSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    options: {
      async handler() {
        this.loading = true
        await this.$store
          .dispatch('announcements/fetchAnnouncementsAction', {
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sortBy: this.options.sortBy,
            sortDesc: this.options.sortDesc,
            search: this.searchString,
            statuses: this.selectedStatuses
          })
          .then((data) => {
            this.loading = false
            this.limit = data.limit
            this.total = data.count
          })
      }
    }
  },
  created() {
    this.$store
      .dispatch('announcements/fetchAnnouncementsAction', {
        page: 1,
        limit: this.options.itemsPerPage,
        statuses: this.selectedStatuses
      })
      .then((data) => {
        this.loading = false
        this.limit = data.limit
        this.total = data.count
      })
  },
  mounted() {
    this.selectAllStatuses()
  },
  methods: {
    async newAnnouncement() {
      if (await this.$refs.newAnnouncement.open()) {
        await this.$store.dispatch('announcements/fetchAnnouncementsAction', {
          page: 1,
          limit: this.options.itemsPerPage,
          statuses: this.selectedStatuses
        })
      }
    },
    async searchAction() {
      this.loading = true
      await this.$store
        .dispatch('announcements/fetchAnnouncementsAction', {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          search: this.searchString,
          statuses: this.selectedStatuses
        })
        .then((data) => {
          this.loading = false
          this.limit = data.limit
          this.total = data.count
        })
    },
    selectAllStatuses() {
      this.$nextTick(() => {
        if (this.allStatusesSelected) {
          this.selectedStatuses = []
        } else {
          this.selectedStatuses = this.statuses.slice().map((t) => t.value)
        }
        this.searchAction()
      })
    },
    getStatusText(status) {
      return this.statuses.find((s) => s.value === status).text || ''
    },
    convertDate(date) {
      return dayjs(date).format('YYYY/MM/DD')
    }
  }
}
</script>

<style scoped>
.v-speed-dial {
  bottom: 5vw;
  right: 3vw;
}
.chip-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}
.v-card,
.v-list {
  border-radius: 12px !important;
}
.v-input {
  border-radius: 10px;
}
.v-btn {
  border-radius: 20px;
}
table tbody tr td {
  border: none !important;
  border-bottom: none !important;
}
p {
  margin-bottom: 0;
}
.date {
  font-size: 12px;
  color: #868a88;
}
.status {
  font-size: 12px;
}
.test {
  border: 2px solid yellow;
}
</style>
